import { NgModule } from '@angular/core';
import { ConfirmDialogComponent } from './confirm-dialog.component';
import { ConfirmDirective } from './confirm.directive';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [
    ConfirmDialogComponent,
    ConfirmDirective
  ],
  imports: [
    MatDialogModule,
    MatButtonModule
  ],
  exports: [ConfirmDirective]
})
export class ConfirmModule {}
